import React, { useMemo } from 'react';
import clsx from 'clsx';
import style from './style.module.scss';

const SoccerViewRecord = ({ home, away }) => {
  const awayRankingClass = useMemo(() => {
    if (!!away.seasonRecord && !!home.seasonRecord) {
      return away.seasonRecord.ranking < home.seasonRecord.ranking;
    } else {
      return false;
    }
  }, [home, away]);
  const homeRankingClass = useMemo(() => {
    if (!!away.seasonRecord && !!home.seasonRecord) {
      return home.seasonRecord.ranking < away.seasonRecord.ranking;
    } else {
      return false;
    }
  }, [home, away]);

  return (
    <>
      <dl className={style.item}>
        <dt>순위</dt>
        <dd className={awayRankingClass ? style.on : ''}>
          {!!away.seasonRecord && away.seasonRecord.ranking}
        </dd>
        <dd className={homeRankingClass ? style.on : ''}>
          {!!home.seasonRecord && home.seasonRecord.ranking}
        </dd>
      </dl>
      <dl className={clsx(style.item, style.large)}>
        <dt>경기수</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.gameCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.gameCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>승점</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.point}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.point}</dd>
      </dl>
      <dl className={style.item}>
        <dt>승</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.winCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.winCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>무</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.drawCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.drawCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>패</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.defeatCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.defeatCount}</dd>
      </dl>

      <dl className={style.item}>
        <dt>득점</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.goalCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.goalCount}</dd>
      </dl>
      <dl className={style.item}>
        <dt>실점</dt>
        <dd>{!!away.seasonRecord && away.seasonRecord.goalAgainstCount}</dd>
        <dd>{!!home.seasonRecord && home.seasonRecord.goalAgainstCount}</dd>
      </dl>
      <dl className={clsx(style.item, style.large)}>
        <dt>득실차</dt>
        <dd>
          {!!away.seasonRecord &&
            away.seasonRecord.goalCount - away.seasonRecord.goalAgainstCount}
        </dd>
        <dd>
          {!!home.seasonRecord &&
            home.seasonRecord.goalCount - home.seasonRecord.goalAgainstCount}
        </dd>
      </dl>
    </>
  );
};

export default SoccerViewRecord;
